module.exports = __webpack_public_path__ + "be3f651568d6245ea8f05549ca51717c.svg";